import { useState } from 'react';
import { useDeleteWorkOrderCharge } from '@api/enterprise/workorder';
import type { WorkOrderPart } from '../types/parts.types';

export const usePartsDeletion = (jobNumber: string) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [partToDelete, setPartToDelete] = useState<WorkOrderPart | null>(null);

  const { mutate: deletePart, isPending: isDeleting } =
    useDeleteWorkOrderCharge();

  const handleDeletePart = (part: WorkOrderPart) => {
    setPartToDelete(part);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (!partToDelete?.sequenceNumber || partToDelete.sequenceNumber < 0) {
      return;
    }

    setIsDeleteModalOpen(false);
    setPartToDelete(null);

    deletePart({
      jobNumber,
      sequenceNumber: partToDelete.sequenceNumber
    });
  };

  const handleCloseModal = () => {
    if (!isDeleting) {
      setIsDeleteModalOpen(false);
      setPartToDelete(null);
    }
  };

  return {
    isDeleteModalOpen,
    partToDelete,
    isDeleting,
    handleDeletePart,
    handleConfirmDelete,
    handleCloseModal
  };
};
